// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { isMobileWeb } from '../../../../../utils';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import AddedToBagActionsLabels, {
  GLOBAL_LABELS,
} from '../../../../features/CnC/AddedToBagActions/container/AddedToBagActions.labels';
import BodyCopy from '../../../atoms/BodyCopy';

import withStyles from '../../../hoc/withStyles';
import Modal from '../../Modal';
import styles from '../styles/SiteMaintenanceBanner.style';

const getInfoIcon = () => {
  return <span className="outer-cont">!</span>;
};

const bannerModal = ({ handleCloseDisclaimer, siteMaintenanceBannerState }) => {
  const headingProps = {
    headingStyle: { className: 'modal-heading hide-on-desktop' },
  };
  return (
    <Modal
      isOpen={siteMaintenanceBannerState}
      onRequestClose={handleCloseDisclaimer}
      overlayClassName="TCPModal__Overlay"
      className="TCPModal__Content"
      inheritedStyles={styles}
      closeIconDataLocator="detailmodalcrossicon"
      fixedWidth
      stickyHeader
      headingAlign="center"
      heading={'Site Maintenance'}
      {...headingProps}
    >
      <div className="disclaimer-text-container">
        <BodyCopy
          fontSize={['fs12', 'fs14', 'fs14']}
          fontWeight="regular"
          fontFamily="secondary"
          textAlign={isMobileWeb() ? 'left' : 'center'}
          className="disclaimer-text-style"
        >
          {renderLabel(
            getDynamicLabelValues('dynamic.global_d.lbl_site_maintenance_popup_text'),
            'lbl_site_maintenance_popup_text'
          )}
        </BodyCopy>
      </div>
    </Modal>
  );
};

const SiteMaintenanceBanner = (props) => {
  const {
    className,
    siteMaintenanceBannerData,
    globalError,
    closeSiteMaintenanceBannerState,
    siteMaintenanceBannerState,
    siteMaintenacePopupEnabled,
  } = props;
  const addedToBagActionsLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_LABELS,
    AddedToBagActionsLabels
  );
  const { subtitle, time, title, date } = siteMaintenanceBannerData || {};

  const handleCloseDisclaimer = () => {
    closeSiteMaintenanceBannerState(false);
  };
  const formatedSubtitle = subtitle?.replace('#date', date)?.replace('#time', time);
  return (
    <div className={className}>
      {siteMaintenanceBannerData && (
        <div className="message-container">
          <div>{getInfoIcon()}</div>

          <div>
            <BodyCopy
              component="span"
              fontFamily="secondary"
              fontWeight="extrabold"
              className="title-text-style"
            >
              {title}
            </BodyCopy>
            <BodyCopy
              component="div"
              fontFamily="secondary"
              fontWeight={globalError ? 'regular' : 'extrabold'}
              color="white"
              className="subtitle-text-style"
            >
              {formatedSubtitle}
            </BodyCopy>
          </div>
        </div>
      )}
      {siteMaintenacePopupEnabled &&
        bannerModal({
          handleCloseDisclaimer,
          siteMaintenanceBannerState,
          addedToBagActionsLabels,
        })}
    </div>
  );
};

export default withStyles(SiteMaintenanceBanner, styles);
